import _api from '../../drivers/_api';
import Driver from '../../../models/Driver';
import DriverOccurrence from '../../../models/DriverOccurrence';
import Store from '../../../models/Store';
import router from '@/router';

export default {
  namespaced: true,
  state: {
    actual: {},
    assignedStores: [],
    assignedStoresPageCount: 15,
    occurrences: [],
    pageCount: 0,
    totalCount: 0,
  },
  getters: {
    actual: (state,) => state.actual,
    firstAssignedStores: (state,) => state.assignedStores.slice(0, 3,),
    assignedStores: (state,) => state.assignedStores,
    filteredAssignedStores: (state,) => (filters,) => state.assignedStores.
      filter((item,) => {
        let confirmation = true;
        Object.entries(filters,).forEach((filter,) => {
          if (filter[1]) {
            if (typeof filter[1] === 'string') {
              confirmation = item[filter[0]].
                toLowerCase().indexOf(filter[1].toLowerCase(),) >= 0;
            } else {
              confirmation = item[filter[0]] === filter[1];
            }
          }
        },);
        return confirmation;
      },),
    assignedStoresPageCount: (state,) => state.assignedStoresPageCount,
    assignedStoresTotalCount: (state,) => state.assignedStores.length,
    occurrences: (state,) => state.occurrences,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
  },
  mutations: {
    newDriver (state,) {
      state.actual = new Driver();
    },
    setDriver (state, driver,) {
      state.actual.driver = driver;
    },
    setDriverOrders (state, orders,) {
      state.actual.orders = orders;
    },
    cleanDriver (state,) {
      state.actual = {};
    },
    setDriverAssignedStores (state, assignedStores,) {
      state.assignedStores = assignedStores.map((store,) => new Store(store,),);
    },
    cleanDriverAssignedStores (state,) {
      state.assignedStores = [];
    },
    setDriverOccurrences (state, occs,) {
      state.occurrences = occs;
    },
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
  },
  actions: {
    async getDriverDetails ({ commit, }, driverID,) {
      commit('cleanDriver',);
      commit('newDriver',);

      await _api.get({ _id: driverID, },).then(
        (response,) => {
          commit('setDriver', response.data,);
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getDriverOrders ({ commit, }, driverID,) {
      _api.getDriverOrders({ _id: driverID, },).then(
        (response,) => {
          commit('setDriverOrders', response.data,);
        },
        () => {
          commit('setDriverOrders', [],);
        },
      );
    },

    getDriverAssignedStores ({ commit, }, driverID,) {
      commit('cleanDriverAssignedStores',);

      _api.getDriverAssignedStores({ _id: driverID, },).then(
        (response,) => {
          commit('setDriverAssignedStores', response.data,);
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },

    getDriverOccurrences: (
      { commit, },
      {
        driverId = router.currentRoute.params.id,
        status,
        code,
        occurrence_date,
        reason,
        financial_occ_type,
        value,
        page,
        sort,
        sortBy,
      },
    ) => {
      commit('driver/setDriverOccurrences', [], { root: true, },);
      return _api.getOccurrence(driverId,
        {
          status,
          code,
          occurrence_date,
          reason,
          financial_occ_type,
          value,
          page,
          sort,
          sortBy,
        },
      ).then(
        (response,) => {
          const occurrence = response.data.items.map(
            (occ,) => new DriverOccurrence(occ,),
          );
  
          commit('driver/setDriverOccurrences', occurrence, { root: true, },);
          commit(
            'driver/setPageCount',
            Math.ceil(response.data.total_count / 15,),
            { root: true, },
          );
          commit('driver/setTotalCount', response.data.total_count, {
            root: true,
          },);
  
          return occurrence;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },

    updateDriver ({ getters, }, valuesToUpdate,) {
      return _api.patch(getters.actual._id, valuesToUpdate,);
    },
    updateDataBank ({ getters, }, valuesToUpdate,) {
      return _api.patchDataBank(getters.actual._id, valuesToUpdate,);
    },
    addDriverVehicles ({ getters, }, valuesToUpdate,) {
      return _api.postVechicle(getters.actual._id, valuesToUpdate,);
    },
    removeDriverVehicles ({ getters, }, idToRemove,) {
      return _api.removeVechicle(getters.actual._id, idToRemove,);
    },
    addDriverAttachment ({ getters, }, valuesToUpdate,) {
      return _api.postAttachment(getters.actual._id, valuesToUpdate,);
    },
    addDriverOccurrence ({ getters, }, occurrence,) {
      return _api.postOccurrence(getters.actual._id, occurrence,);
    },
    updateDriverOccurrence ({ getters, }, {occId, payload,},) {
      return _api.patchOccurrence(getters.actual._id, occId, payload,);
    },
    removeDriverOccurrence ({ getters, }, idToRemove,) {
      return _api.removeOccurrence(getters.actual._id, idToRemove,);
    },
    removeDriverAttachment ({ getters, }, idToRemove,) {
      return _api.removeAttachment(getters.actual._id, idToRemove,);
    },
    updateDriverTeams ({ getters, }, { added_teams, removed_teams, },) {
      return _api.updateDriverTeams({
        _id: getters.actual._id,
        added_teams, removed_teams,
      },);
    },
    updateDriverVehicle ({ getters, }, valuesToUpdate,) {
      return _api.patchVechicle(getters.actual._id, valuesToUpdate,);
    },
  },
};
